export default __webpack_public_path__ + "static/media/gallery_06.abe656fa.jpg";